<template>
  <!-- new code -->
  <v-card class="box">
     <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="box">
        <v-toolbar class="toolbar">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Match The Pair</v-toolbar-title>
          <!-- <v-toolbar-items>
            <v-btn dark text @click="show = false">Close</v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <div style="margin: 0px">
          <v-snackbar
            v-model="snackbar"
            :top="true"
            :color="color"
            :timeout="6000"
          >
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
          <v-card>
            <!-- <marquee class="slide" behavior="slide" direction="left">*NOTE:File size should be less than {{filesize}} & File only in <span v-for="type in imgtype" :key="type">{{type.imagetype}} </span> Format!!! </marquee> -->
            <br />

            <v-card>
              <!-- ck editor show -->
              <div>
                <v-btn icon @click="showEditor" style="float: right">
                  <v-icon title="CK Text Editor" color="black"
                    >mdi-file-edit-outline</v-icon
                  ></v-btn
                >
                <!-- </v-col> -->
              </div>
              <v-row>
                <v-col cols="12" sm="1" md="1"></v-col>
                <v-col cols="12" sm="6" md="6">
                  <!-- <span>Question Title/No.{{qno}}</span><br> -->
                  <p class="p-0 m-0"><b>Question Title</b></p>
                  <v-textarea
                    label="Question Title"
                    auto-grow
                    v-model="question"
                    outlined
                    rows="3"
                  ></v-textarea>

                  <!-- <ckeditor v-model="question" :config="editorConfig"></ckeditor> -->
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-file-input
                    v-model="qfile"
                    hint="Question Image File size Should be less than 200kb And It Should be in JPEG Format"
                    accept="image/jpeg, image/jpg"
                    id="file"
                    prepend-icon="mdi-attachment"
                    label="Choose File"
                    show-size
                    name="doc"
                    @change="validateFile(qfile, 'question')"
                  ></v-file-input>
                  <br />
                  <span v-if="q_file_name">
                    <a
                      class="p-2"
                      :href="basepath + q_file_path + q_file_name"
                      target="blank"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-if="q_file_path != null"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="black">mdi-eye</v-icon></v-btn
                          >
                        </template>
                        <span> View Previous Question File!!! </span>
                      </v-tooltip>
                    </a>
                  </span>
                  <span v-if="q_file_name != null">
                    <v-btn
                      color="error"
                      fab
                      x-small
                      outlined
                      icon
                      @click="getdeletefileopt('question_file')"
                    >
                      <v-avatar style="" class="delete-avatar">
                        <v-icon color="erro" class="delete-v-icon"
                          >delete</v-icon
                        >
                      </v-avatar>
                    </v-btn>
                  </span>
                </v-col>
              </v-row>
            </v-card>

            <v-dialog v-model="imageSizeFlag" persistent max-width="400px">
              <v-card>
                <v-card-title class="headline"> File Size </v-card-title>
                <v-container>
                  <span>
                    <v-col cols="12" xs="12" sm="12">
                      <p class="slide">
                        File size should be less than {{ kb }}!
                      </p>
                    </v-col>
                  </span>
                  <center>
                    <v-btn class="button" text @click="imageSizeFlag = false"
                      >OK</v-btn
                    >
                  </center>
                </v-container>
              </v-card>
            </v-dialog>
            <v-dialog v-model="imageExtFlag" persistent max-width="400px">
              <v-card>
                <v-card-title class="headline"> File Format </v-card-title>
                <v-container>
                  <span>
                    <v-col cols="12" xs="12" sm="12" md="12">
                      <p class="slide">
                        File only in
                        <span v-for="type in imagetype" :key="type">{{
                          type.imagetype
                        }}</span>
                        Format!!!
                      </p>
                    </v-col>
                  </span>
                  <center>
                    <v-btn class="button" @click="imageExtFlag = false"
                      >OK</v-btn
                    >
                  </center>
                </v-container>
              </v-card>
            </v-dialog>
            <v-form id="mtf_form" @submit.prevent="submit">
              <v-card v-for="(input, index) in inputs" in :key="index">
                <input type="hidden" v-model="input.mtf_id" />
                <v-row justify="center">
                  <v-col cols="12" sm="4" md="4">
                    <p class="p-0 m-0">
                      <b>Question - {{ index + 1 }}</b>
                    </p>
                    <v-textarea
                      label="Question"
                      auto-grow
                      v-model="input.sub_question"
                      outlined
                      rows="3"
                    ></v-textarea>

                    <!-- <ckeditor v-model="input.sub_question" :config="editorConfig"></ckeditor> -->
                    <v-file-input
                      accept="image/*"
                      v-model="input.sub_question_file"
                      hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
                      prepend-icon="mdi-attachment"
                      label="Choose File"
                      id="file1"
                      show-size
                      name="que"
                      @change="
                        validateFileOptions(
                          input.sub_question_file,
                          index,
                          'addedque'
                        )
                      "
                    ></v-file-input>
                    <br />
                    <span>
                      <a
                        v-if="input.questionfilename != null"
                        class="p-2"
                        :href="
                          basepath +
                          input.questionfilepath +
                          input.questionfilename
                        "
                        target="blank"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon color="black">mdi-eye</v-icon></v-btn
                            >
                          </template>
                          <span> View Previous File!!! </span>
                        </v-tooltip>
                      </a>
                    </span>
                    <span v-if="input.questionfilename != null">
                      <v-btn
                        color="error"
                        fab
                        x-small
                        outlined
                        icon
                        @click="
                          getdeletefileopt('sub_question_file', input.mtf_id)
                        "
                      >
                        <v-avatar style="" class="delete-avatar">
                          <v-icon
                            title="Remove Question file"
                            color="erro"
                            class="delete-v-icon"
                            >delete</v-icon
                          >
                        </v-avatar>
                      </v-btn>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="1" md="1" justify="center">
                    <v-icon color="black" class="format-icon"
                      >mdi-arrow-left-right-bold</v-icon
                    >
                    <!-- <i class="fa fa-arrows-h format-icon" aria-hidden="true"></i> -->
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <p class="p-0 m-0"><b>Correct Answer</b></p>
                    <v-textarea
                      label="Answer"
                      auto-grow
                      v-model="input.sub_answer"
                      outlined
                      rows="3"
                    ></v-textarea>

                    <!-- <ckeditor v-model="input.sub_answer" :config="editorConfig"></ckeditor> -->
                    <v-file-input
                      accept="image/*"
                      v-model="input.sub_answer_file"
                      hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
                      prepend-icon="mdi-attachment"
                      label="Choose File"
                      id="file1"
                      show-size
                      name="ans"
                      @change="
                        validateFileOptions(
                          input.sub_answer_file,
                          index,
                          'addedans'
                        )
                      "
                    ></v-file-input>
                    <br />

                    <span>
                      <a
                        v-if="input.answerfilename != null"
                        class="p-2"
                        :href="
                          basepath + input.answerfilepath + input.answerfilename
                        "
                        target="blank"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon color="black">mdi-eye</v-icon></v-btn
                            >
                          </template>
                          <span> View Previous File!!! </span>
                        </v-tooltip>
                      </a>
                    </span>

                    <span v-if="input.answerfilename != null">
                      <v-btn
                        color="error"
                        fab
                        x-small
                        outlined
                        icon
                        @click="
                          getdeletefileopt('sub_answer_file', input.mtf_id)
                        "
                      >
                        <v-avatar style="" class="delete-avatar">
                          <v-icon
                            title="Remove Answer file"
                            color="erro"
                            class="delete-v-icon"
                            >delete</v-icon
                          >
                        </v-avatar>
                      </v-btn>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="1" md="1">
                    <p class="p-0 m-0"><b>Weightage</b></p>
                    <v-text-field
                      class="p-0 m-0"
                      v-model.trim="input.marks"
                      type="number"
                      required
                    ></v-text-field>
                    <!-- <v-select class="p-0 m-0" :items="marks_list" v-model.trim="input.marks "  v-if="is_graded" item-value="id" item-text="marks" required></v-select> -->
                    <br />
                    <v-btn
                      color="red"
                      fab
                      small
                      dark
                      @click="deleteRow(index)"
                      class="del"
                      v-if="input.mtf_id == null"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                      color="green"
                      fab
                      small
                      dark
                      @click="getdeletepair(input.mtf_id)"
                      class="del"
                      v-else
                    >
                      <v-icon title="Remove Option">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
              <br />
              <div v-show="this.optionsize <= 20">
                <v-btn
                  color="indigo"
                  fab
                  small
                  dark
                  @click="addRow"
                  style="margin-left: 10px"
                >
                  <v-icon title="Add New Option">mdi-plus</v-icon>
                </v-btn>
              </div>
            </v-form>
            <v-card-actions>
              <v-row justify="center">
                <v-btn class="button" @click="savemcqassignment">Save</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
          <div class="text-center">
            <v-dialog
              v-model="dialog_upload"
              hide-overlay
              persistent
              width="300"
            >
              <v-card color="primary" dark>
                <v-card-text>
                  Please Wait
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <!-- Delete Dialog -->
          <v-dialog v-model="dialog_delete" persistent max-width="290">
            <v-card>
              <v-card-title class="headline"> Delete File </v-card-title>
              <v-card-text> Do you want to Delete this file? </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog_delete = false"
                >
                  No
                </v-btn>
                <v-btn color="green darken-1" text @click="removeoptfile">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Delete Pair Dialog -->
          <v-dialog v-model="dialog_delete_pair" persistent max-width="290">
            <v-card>
              <v-card-title class="headline"> Delete Pair </v-card-title>
              <v-card-text> Do you want to Delete this Pair? </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog_delete_pair = false"
                >
                  No
                </v-btn>
                <v-btn color="green darken-1" text @click="removepair">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogSize" persistent max-width="400px">
            <v-card>
              <v-card-title class="headline"> File Size </v-card-title>
              <v-container>
                <span>
                  <v-col cols="12" xs="12" sm="12">
                    <p class="slide">File size should be less than {{ kb }}!</p>
                  </v-col>
                </span>
                <center>
                  <v-btn class="button" text @click="dialogSize = false"
                    >OK</v-btn
                  >
                </center>
              </v-container>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogExt" persistent max-width="400px">
            <v-card>
              <v-card-title class="headline"> File Format </v-card-title>
              <v-container>
                <span>
                  <v-col cols="12" xs="12" sm="12" md="12">
                    <p class="slide">
                      File only in
                      <span v-for="type in imagetype" :key="type"
                        >{{ type.imagetype }}
                      </span>
                      Format!!!
                    </p>
                  </v-col>
                </span>
                <center>
                  <v-btn class="button" text @click="dialogExt = false"
                    >OK</v-btn
                  >
                </center>
              </v-container>
            </v-card>
          </v-dialog>
        </div>
      </v-card>
      <!-- show editor -->
      <v-row justify="center">
        <v-dialog
          v-model="show_editor"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar class="toolbar">
              <v-btn icon dark @click="show_editor = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Text Editor</v-toolbar-title>
              <!-- <v-toolbar-items>
              <v-btn dark text @click="show_editor = false">Close</v-btn>
            </v-toolbar-items> -->
            </v-toolbar>
            <br />
            <v-row dense justify="center">
              <v-col cols="12" sm="7" md="7">
                <ckeditor
                  v-model="textEditor"
                  :config="editorConfig"
                ></ckeditor>
              </v-col>
              <v-col cols="12" sm="3" md="3" v-if="textEditor">
                <span
                  ><v-icon
                    class="icon-quick"
                    title="Copy text"
                    @click="copy(textEditor)"
                    >mdi-content-copy</v-icon
                  ></span
                >
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-row>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: ["mtp_id", "value"], //mcq_id -> assignment id --> (mcq_data) -> assignment_off
  data: () => ({
    editorConfig: {
      height: "80px",
      extraPlugins: "mathjax",
      mathJaxLib:
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
    },
    loader: false,
    assignment_data: [], 
    c_id: null,
    marks_list: [
      { id: 0, marks: "Select Mark" },
      { id: 1, marks: "1" },
      { id: 2, marks: "2" },
      { id: 3, marks: "3" },
      { id: 4, marks: "4" },
      { id: 5, marks: "5" },
      { id: 6, marks: "6" },
      { id: 7, marks: "7" },
      { id: 8, marks: "8" },
      { id: 9, marks: "9" },
      { id: 10, marks: "10" },
    ],
    dialog_delete: false,
    dialog_delete_pair: false,
    valid: false,
    dialog_upload: false,
    current_course: null,
    c_id: null,
    dialog_save: false,
    course_name: null,
    course_code: null,
    question: null,
    qfile: null,
    q_file_path: null,
    q_file_name: null,
    weightage: 1,
  
    imagetype: [],
    optionsize: 0,
    inputs: [],
    //mtf_id:null,
    imageSizeFlag: false,
    imageExtFlag: false,
    kb: null,
    dialogSize: false,
    dialogExt: false,
    filesize: null,
    imgtype: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    total_weightage: 0,
    basepath: null,
    quizQuestion_id: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    show_editor: false,
    textEditor: "",quiztype:null
  }),
  updated: function () {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    });
  },
  methods: {
     showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    showEditor() {
      this.show_editor = true;
    },
    copy(text) {
      navigator.clipboard.writeText(text);
      //   alert("Text copied to clipboard!!!");
      this.showSnackbar("#4caf50", "Text copied to clipboard!!!");
    },
    validatedata() {
      axios
        .post("/MatchThePairAssignment/validatefile")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.filesize = res.data.imagesize / 1000 + "KB";
            this.imgtype = res.data.imagetype;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);
        });
    },
    //Methods For add option
    addRow() {
      this.inputs.push({
        sub_question: null,
        sub_question_file: null,
        sub_answer: null,
        sub_answer_file: null,
        mtf_id: null,
        marks: 1,
      });
      this.optionsize++;
    },
    deleteRow(index) {
      this.inputs.splice(index, 1);
      this.optionsize--;
    },
    validateFile(filename, demo) {
      let invalid;
      let file1 = filename;
      let file_size1 = file1.size;
      let file_name1 = filename.name;
      let ext1 = file_name1.split(".").pop();
      let formData = new FormData();
      // alert(file_size1)
      axios
        .post("/MatchThePairAssignment/validatefile")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.imagesize = res.data.imagesize;
            this.kb = this.imagesize / 1000 + "KB";
            if (file_size1 > this.imagesize) {
              this.dialogSize = true;
              if (demo == "question") {
                this.qfile = null;
              }
            } else {
              //alert("Less File")
              this.dialogSize = false;
            }
            this.imagetype = res.data.imagetype;
            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext1 == this.imagetype[i].imagetype.trim()) {
                // alert("file ok")
                this.dialogExt = false;
                return;
              } else {
                //  alert("else")
                this.dialogExt = true;
                invalid = "invalidfile";
                //return;
              }
            }
            if (invalid == "invalidfile") {
              if (demo == "question") {
                this.qfile = null;
              }
            }
          } else {
            this.showsnackbar("Something went wrong...", "error", 1000);
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);
        });
    },
     validateFileOptions(filename,index,demo) {
      let file1 = filename;
      let invalid = "";
      let file_size1 = file1.size;
      let file_name1 = filename.name;
      let ext1 = file_name1.split(".").pop();
      const data = {
        type: this.quiztype,
      };
      axios
        .post("/QuizQuestionBank/validatefile", data)
        .then((res) => {
           if (res.data.flag == "YES") {
            console.log(res.data.imagesize);
            this.imagesize = res.data.imagesize;
            if (file_size1 > this.imagesize) {
              this.dialogSize = true;
              if (demo == "addedque") {
                this.inputs[index].sub_question_file = null;
              }
              if (demo == "addedans") {
                this.inputs[index].sub_answer_file = null;
              }
            } else {
              this.dialogSize = false;
            }
            console.log(res.data.imagetype);
            this.imagetype = res.data.imagetype;

            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext1 == this.imagetype[i].imagetype) {
                this.dialogExt = false;
                return;
              } else {
                //alert("in else")
                this.dialogExt = true;
                invalid = "invalidfile";
              }
            }
            if (invalid == "invalidfile") {
              if (demo == "addedque") {
                this.inputs[index].sub_question_file = null;
              }
              if (demo == "addedans") {
                this.inputs[index].sub_answer_file = null;
              }
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        });
    },
    validateFileAdd(filename, index, demo) {
      let file1 = filename;
      let invalid = "";
      let file_size1 = file1.size;
      let file_name1 = filename.name;
      let ext1 = file_name1.split(".").pop();
      let formData = new FormData();
      // alert(file_size1)
      axios
        .post("/MatchThePairAssignment/validatefile")
        .then((res) => {
          if (res.data.flag == "YES") {
            console.log(res.data.imagesize);
            this.imagesize = res.data.imagesize;
            if (file_size1 > this.imagesize) {
              this.dialogSize = true;
              if (demo == "addedque") {
                this.inputs[index].sub_question_file = null;
              }
              if (demo == "addedans") {
                this.inputs[index].sub_answer_file = null;
              }
            } else {
              this.dialogSize = false;
            }
            console.log(res.data.imagetype);
            this.imagetype = res.data.imagetype;

            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext1 == this.imagetype[i].imagetype) {
                this.dialogExt = false;
                return;
              } else {
                //alert("in else")
                this.dialogExt = true;
                invalid = "invalidfile";
              }
            }
            if (invalid == "invalidfile") {
              if (demo == "addedque") {
                this.inputs[index].sub_question_file = null;
              }
              if (demo == "addedans") {
                this.inputs[index].sub_answer_file = null;
              }
            }
          } else {
            //this.showsnackbar("Something went wrong...", "error", 1000);
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("#b71c1c", "Something went wrong !!!");
    },
    onload() {
      const data = {
        q_id: this.mtp_id,
      };
      axios
        .post("/LiveClass/getQuizQuestionData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inputs = res.data.mtf_all_data;
            this.question = res.data.assignment_text;
            this.course_name = res.data.course;
            this.q_file_name = res.data.assignment_file_name;
            this.q_file_path = res.data.assignment_file_path;
            this.quizQuestion_id = res.data.quizQuestion_id;
            this.quiztype = res.data.quiztype;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);
        });
    },
    savemcqassignment() {
      var el_down = document.getElementById("GFG_DOWN");
      var form = document.getElementById("mtf_form");
      let formData = new FormData(form);
      //alert(this.duedate)
      if (this.qfile == null && this.question == null) {
        this.showSnackbar(
          "#b71c1c",
          "Either option text or option image file is compulsary please add..."
        ); // show snackbar
      } else {
        this.total_weightage = 0;
        for (let i = 0; i < this.inputs.length; i++) {
          this.total_weightage += parseFloat(this.inputs[i].marks);
          formData.append("sub_id", i);
          formData.append("mtf_id", this.inputs[i].mtf_id);
          formData.append("sub_question", this.inputs[i].sub_question);
          formData.append("sub_answer", this.inputs[i].sub_answer);
          formData.append("marks", this.inputs[i].marks);
          if (
            this.inputs[i].sub_question == "" &&
            this.inputs[i].sub_question_file == ""
          ) {
            this.showSnackbar(
              "#b71c1c",
              "Either option text or option image file is compulsary please add..."
            ); // show snackbar
            return;
          }
          if (
            this.inputs[i].sub_answer == "" &&
            this.inputs[i].sub_answer_file == ""
          ) {
            this.showSnackbar(
              "#b71c1c",
              "Either option text or option image file is compulsary please add..."
            ); // show snackbar
            return;
          }
        }
        formData.append("question", this.question);
        formData.append("total_weightage", this.total_weightage);
        formData.append("qfile", this.qfile);
        formData.append("q_id", this.mtp_id);
        this.dialog_upload = true;
        axios
          .post("/LiveClass/saveEditMTP", formData, {})
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("green", "Updated Successfully"); // show snackbar
              this.dialog_upload = false;
              this.inputs = [];
              this.reset();
              // $(window).scrollTop($('#GFG_DOWN').position().top);
            }
          })
          .catch((error) => {
            this.showSnackbar("red", "Something went wrong..."); // show snackbar
            this.dialog_upload = false;
          })
          .finally(() => {});
      }
    },
    reset() {
      (this.question = null),
        (this.qfile = null),
        (this.iscorrect_01 = null),
        (this.optfile1 = null),
        (this.optfile2 = null),
        (this.option_01 = null),
        (this.option_02 = null);
      this.inputs = [];
    },
    getdeletefileopt(msg, mtf_id) {
      this.del_msg = msg;
      this.dialog_delete = true;
      this.mtf_id = mtf_id;
    },
    removeoptfile() {
      this.dialog_delete = false;
      const data = {
        q_id: this.quizQuestion_id,
        filetype: this.del_msg,
        mtf_id: this.mtf_id,
      };
      this.dialog = true;
      axios
        .post("/LiveClass/deletemtfFile", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "File Deleted Successfully"); // show snackbar
            this.onload();
            this.dialog = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("red", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getdeletepair(mtf_id) {
      this.dialog_delete_pair = true;
      this.mtf_id = mtf_id;
    },
    removepair() {
      this.dialog_delete_pair = false;
      const data = {
        mtf_id: this.mtf_id,
      };
      this.dialog = true;
      axios
        .post("/LiveClass/deletemtfpair", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Pair Deleted Successfully"); // show snackbar
            this.onload();
            this.dialog = false;
          }
        })
        .catch((error) => {
           this.showSnackbar("red", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },

  mounted() {
    //alert("mtp_id"+ this.mtp_id)
    this.onload();
    this.basepath = localStorage.getItem("awspath");
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style scoped>
.format-icon {
  margin-top: 100%;
  font-size: 40px;
  text-align: center;
}
.toolbar {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}
.btn-submit:hover {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}
.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}
.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}
.msg {
  color: red;
}
.btn-submit-align {
  float: right;
  margin: 1rem !important;
}
.btn-submit:hover {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
.name {
  color: #ffb500;
  font-weight: bold;
  letter-spacing: 1px;
}

v-chip {
  width: auto;
}
.card-border {
  background-color: #add8e630;
  margin: 8px !important;
  padding: 8px;
  border: 2px solid rgb(195, 214, 218) !important;
  border-radius: 10px;
}

.text {
  color: darkblue !important;
  margin-left: 40px;
}
.card-border1 {
  margin: 8px !important;
  padding: 8px;
  border: 2px solid white !important;
  border-radius: 10px;
}
</style>
